import { pick } from 'lodash-es';
import { FormItemAttachmentType, VendorDetailDto } from '@purchase/supplier';

export const formatSupplierDetailExternal = (
  detail: VendorDetailDto | undefined
) => {
  if (!detail) {
    return undefined;
  }
  const newDetail = { ...detail } as any;

  // ── successCase 合并 ──
  const successCase = newDetail?.extendAttributeInfo?.successCase;
  if (Array.isArray(successCase)) {
    const res = [];
    successCase.forEach((item: any, i: number) => {
      item.successCaseDetail?.forEach((detail: any, index: number) => {
        res.push({
          ...detail,
          ...item,
          $rowSpan: index === 0 ? item.successCaseDetail.length : 0,
          $index: i,
        });
      });
    });
    newDetail.extendAttributeInfo.successCase = res;
  }

  // ── exclusiveResourceDetails 合并 ──
  const exclusiveResourceDetails =
    newDetail?.extendAttributeInfo?.serviceInformation
      ?.exclusiveResourceDetails;
  if (Array.isArray(exclusiveResourceDetails)) {
    const res: any[] = [];
    exclusiveResourceDetails.forEach((item: any, i: number) => {
      const influencers = item.influencerInfoDetails;
      if (Array.isArray(influencers) && influencers.length > 0) {
        influencers.forEach((influencer: any, index: number) => {
          res.push({
            ...influencer,
            ...item,
            influencerInfoDetails: undefined,
            $rowSpan: index === 0 ? influencers.length : 0,
            $index: i,
          });
        });
      } else {
        res.push({
          ...item,
          influencerInfoDetails: undefined,
          $rowSpan: 1,
          $index: i,
        });
      }
    });
    newDetail.extendAttributeInfo.serviceInformation.exclusiveResourceDetails =
      res;
  }

  // ── 第三方数据来源标记 ──
  const appendDataSource = (list: any[] | undefined, source: string) =>
    list?.map((item: any) => ({ ...item, dataSource: source }));

  // 企查查实际控制人
  if (newDetail.vendorQccActualControllerInfos) {
    newDetail.vendorQccActualControllerInfos = appendDataSource(
      newDetail.vendorQccActualControllerInfos,
      'QCC'
    );
  }
  // 企查查主要人员
  if (newDetail.vendorQccKeyMemberInfos) {
    newDetail.vendorQccKeyMemberInfos = appendDataSource(
      newDetail.vendorQccKeyMemberInfos,
      'QCC'
    );
  }

  // ── 股东信息：合并历史股东 & 标记数据来源 ──
  const vendorShareholderInfos =
    appendDataSource(newDetail.vendorShareholderInfos ?? [], 'QCC') ?? [];
  const vendorQccHistoryShareholderInfos =
    appendDataSource(newDetail.vendorQccHistoryShareholderInfos ?? [], 'QCC') ??
    [];
  const shareholderCount = vendorShareholderInfos.length;

  // 回写已标记来源的股东列表
  newDetail.vendorShareholderInfos = vendorShareholderInfos;

  if (vendorQccHistoryShareholderInfos.length > 0) {
    const vendorShareholderWithHistoryInfos = [
      ...vendorShareholderInfos,
      ...vendorQccHistoryShareholderInfos.map((item: any, i: number) => ({
        ...item,
        $index: shareholderCount + i + 1,
        isHistory: true,
      })),
    ];
    newDetail.vendorShareholderWithHistoryInfos =
      vendorShareholderWithHistoryInfos;
  }

  // ── 聚合展示字段组装

  if (newDetail.vendorBasicInfo) {
    newDetail.vendorBasicInfo.insuredNumberWithFile = pick(
      newDetail.vendorBasicInfo,
      ['insuredNumber', 'supportingFiles']
    );
    newDetail.vendorBasicInfo.licenseRangeDateWithFile = pick(
      newDetail.vendorAttachmentInfo,
      [
        'licenseFile',
        'businessLicenseFile',
        'businessRegistrationFile',
        'fileDateRange',
        'longEffective',
      ]
    );
  }

  // ── 相关材料：拆分默认展示附件 ──
  // 默认只展示 公司介绍材料、商业道德责任书、保密承诺函
  const AttachmentType = FormItemAttachmentType.Type;
  const DEFAULT_ATTACHMENT_TYPES = [
    AttachmentType.BusinessEthicsResponsibilityLetter,
    AttachmentType.ConfidentialityCommitmentLetter,
    AttachmentType.CompanyIntroductionMaterial,
  ];
  const otherAttachments =
    newDetail.vendorAttachmentInfo?.otherAttachments ?? [];
  if (otherAttachments.length > 0) {
    newDetail.vendorAttachmentInfo.defaultOtherAttachments = otherAttachments
      .filter((item: any) =>
        DEFAULT_ATTACHMENT_TYPES.includes(item.attachmentType)
      )
      .map((item: any) => ({
        ...item,
        fileExpiredDateOrLongEffective: pick(item, [
          'fileExpiredDate',
          'longEffective',
        ]),
      }));
  }

  return newDetail;
};
